import Storable from '@/mixins/storable';
import { THESAURUS_SUGGESTIONS_BUTTON } from '@/plugins/quilljs';
import get from 'lodash/get';
import $http from '@/api';
import { delay } from '@/utils';

const loadingHtml = '<i class="v-icon fa fa-circle-o-notch fa-spin" style="font-size: 18px"></i>';
const successHtml = '<i class="material-icons info--text" style="font-size: 18px">check_circle</i>';
const errorHtml = '<i class="material-icons red--text" style="font-size: 18px">error</i>';

export default {
  mixins: [Storable],
  inject: {
    $getParentEditor: { default: null },
  },
  props: {
    thesaurusTaxonsFields: {
      type: Array,
      default: () => ([
        'mainTaxonomyId',
        'secondaryTaxonomyIds',
      ]),
    },
    thesaurusBodyField: {
      type: String,
      default: 'body',
    },
  },
  computed: {
    storePath() {
      return this.$getParentEditor ? this.$getParentEditor().storePath : 'content/editor';
    },
  },
  data() {
    return {
      thesaurusButton: null,
      thesaurusLoading: false,
    };
  },
  methods: {
    thesaurusAddEventListener(currentTry = 1) {
      this.thesaurusButton = document.querySelector(`.ql-${THESAURUS_SUGGESTIONS_BUTTON}`);

      if (this.thesaurusButton) {
        this.thesaurusButton.addEventListener('click', this.thesaurusMakeSuggestions);
      } else if (currentTry <= 5) {
        this.$nextTick(this.addUndoRedoButtons.bind(this, currentTry + 1));
      }
    },
    thesaurusRemoveEventListener() {
      if (this.thesaurusButton) {
        this.thesaurusButton.removeEventListener('click', this.thesaurusMakeSuggestions);
      }
    },
    async thesaurusMakeSuggestions() {
      if (this.thesaurusLoading) return;
      this.thesaurusStartLoading();

      const taxons = this.thesaurusTaxonsFields
        .flatMap(field => get(this.getters, `draft.${field}`, []))
        .map(taxon => get(taxon, 'id', taxon));
      const body = get(this.getters, `draft.${this.thesaurusBodyField}`, []);
      const payload = { taxons, body };

      try {
        const response = await $http.post('/api/thesaurus/suggestions', payload);
        const resultBody = get(response, 'body', null);
        if (resultBody) {
          this.$emit('input', resultBody);
          this.$emit('blur', resultBody);
          this.thesaurusButton.innerHTML = successHtml;
        } else {
          this.thesaurusButton.innerHTML = errorHtml;
        }
      } catch (e) {
        console.log('Error when thesaurus suggesting', e);
        this.thesaurusButton.innerHTML = errorHtml;
      } finally {
        await delay(1000);
        this.thesaurusFinishLoading();
      }
    },
    thesaurusStartLoading() {
      this.thesaurusLoading = true;
      this.thesaurusPreviousButtonMarkup = this.thesaurusButton.innerHTML;
      this.thesaurusButton.innerHTML = loadingHtml;
    },
    thesaurusFinishLoading() {
      this.thesaurusLoading = false;
      this.thesaurusButton.innerHTML = this.thesaurusPreviousButtonMarkup;
    },
  },
  beforeDestroy() {
    this.thesaurusRemoveEventListener();
  },
};
